import React from "react";
import {
  Box,
  Button,
  CardMedia,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";

import photo from "../assets/contact.png";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  container: {
    display: "grid",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "25% auto",
    gap: spacing(10),
  },
  image: {
    margin: `0 0 ${spacing(1)}px 0`,
  },
  img: {
    height: "100%",
  },
  contact: {
    display: "grid",
    gridTemplateRows: "70% 30%",
  },
  title: {
    fontWeight: "bold",
    fontSize: "54px",
    lineHeight: "100%",
    margin: `${spacing(3)}px 0`,
    color: "	#404040",
    textShadow: " 4px 4px 30px rgba(150, 150, 150, 0.53)",
    marginBottom: "30px",
  },
  form: {
    margin: `0 ${spacing(3)}px 0 0`,
    display: "grid",
    gridTemplateColumns: "auto auto",
    gridTemplateRows: "repeat(4, 1fr)",
    gap: spacing(4),
  },
  messageField: {
    gridColumn: "1/3",
  },
  submitBtn: {
    gridColumn: "2/3",
    justifySelf: "end",
  },
  icons: {
    display: "flex",
    flexDirection: "column",
  },
  instagram: {
    display: "flex!important",
    alignContent: "center!important",
    alignItems: "center!important",
    textDecoration: "none !important",
    color: "#5B3483 !important",
    marginBottom: "10px !important",
  },
  facebook: {
    display: "flex!important",
    alignContent: "center!important",
    alignItems: "center!important",
    textDecoration: "none !important",
    color: "#5B3483 !important",
  },
  textLink: {
    marginLeft: "7px",
    color: "#997DB5 !important",
    fontWeight: "bold",
    fontSize: "22px",
    fontFamily: "Source Sans Pro",
    fontStyle: "normal",
  },
}));

const Contact = () => {
  const classes = useStyles();

  return (
    <div className="content">
      <Box component="div" className={classes.container}>
        <Box component="div" className={classes.image}>
          <CardMedia className={classes.img} component="img" image={photo} />
        </Box>
        <Box component="div" className={classes.contact}>
          <Box component="div" className={classes.formContainer}>
            <Typography className={classes.title} variant="h3">
              Contactanos
            </Typography>
            <Box component="form" className={classes.form}>
              <TextField
                placeholder="Introduce tu nombre"
                label="Nombre"
                focused
              />
              <TextField
                placeholder="Introduce tu apellido"
                label="Apellido"
                focused
              />
              <TextField
                placeholder="Introduce tu correo"
                label="Correo"
                focused
              />
              <TextField
                placeholder="Introduce tu telefono"
                label="Telefono"
                focused
              />
              <TextField
                className={classes.messageField}
                placeholder="Introduce tu mensaje"
                label="Mensaje"
                focused
              />
              <Button
                className={classes.submitBtn}
                size="small"
                type="submit"
                variant="contained"
                color="primary"
              >
                Enviar
              </Button>
            </Box>
          </Box>
          <Box component="div" className={classes.follow}>
            <Typography className={classes.title} variant="h3">
              Síguenos
            </Typography>
            <Box component="div" className={classes.icons}>
              <a
                target="_blank"
                href="http://instagram.com/iluminartegt"
                className={classes.instagram}
              >
                <InstagramIcon />{" "}
                <span className={classes.textLink}>@iluminartegt</span>
              </a>
              <a
                target="_blank"
                href="http://facebook.com/iluminarte.gt"
                className={classes.facebook}
              >
                <FacebookIcon />{" "}
                <span className={classes.textLink}>/iluminarte.gt</span>
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Contact;
